module.exports = __webpack_public_path__ + "static/media/destination_2.0e7bd4a2.jpg";